import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Button,
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Drawer,
  PaginationItem,
  Alert,
  Snackbar,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import { get, put } from "../../../../utils/api";
import FilterSidebar from "../../../../Components/Masters/Filter/FilterSidebar";
import AddMachinery from "./AddMachinery";
import DateFilter from "./Filters/Date";
import MachineTypeFilter from "./Filters/MachineTypeFilter";
import CategoryFilter from "./Filters/CategoryFilter";
import ApplyButton from "../../Roles and Permissions/Filters/ApplyButton";
import ResetButton from "../../Roles and Permissions/Filters/ResetButton";
import MachineryNameFilter from "./Filters/MachineryName";
import FuelTypeFilter from "./Filters/FuelType";
import View from "./View";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import PaginationBox from "../../../../Components/Masters/Pagination";
import { styled } from "@mui/material/styles";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../Layout/MastersSidebar";
import { useUser } from "../../../../context/AuthContext";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { formatDateMonth } from "../../../../utils/formatDate";

const Machinery = () => {
  const { user } = useUser();

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUserIndex, setSelectedUserIndex] = useState(null);
  const [machinery, setMachinery] = useState([]);
  const [filteredMachinery, setFilteredMachinery] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [indexMachinery, setIndexMachinery] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Category: false,
    MachineryName: false,
    FuelType: false,
    MachineType: false,
  });
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const filters = ["Date", "Machinery Category", "Machinery Type", "Fuel Type"];
  const [DeleteIndex, setDeleteIndex] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [errors, setErrors] = useState({
    Date: false,
    MachineryName: false,
    Category: false,
    FuelType: false,
    MachineType: false,
  });
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState([]);
  const [selectedMachineryNames, setSelectedMachineryNames] = useState([]);
  const [machineryNames, setMachineryNames] = useState([]);
  const [selectedFuelTypes, setSelectedFuelTypes] = useState([]);
  const [fuelTypes, setFuelTypes] = useState([]);
  const [machineTypes, setMachineTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);

  const [viewMachinery, setViewMachinery] = useState(false);
  const [dataView, setDataView] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedMachinery, setSelectedMachinery] = useState(null);
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    selectedCategories: [],
    selectedTypes: [],
    selectedMachineryNames: [],
    selectedFuelTypes: [],
  });

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight;
      const screenHeight = window.innerHeight;
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [machinery]);

  const fetchMachinery = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    // const fetchMachinery = async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage,
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      // console.log("Query Params sent to API:", queryParams); // Debugging line

      await get(`/master/getAllMachinery?${queryParams}`)
        .then((res) => {
          setMachinery(res.data.data);
          setTotalPages(res.data.totalPages);
          setFilteredMachinery(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });

      // console.log("Fetched data after filtering:", response.data); // Debugging line
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchMachinery();
  }, [page, rowsPerPage, sortConfig]);

  const handleAddRole = () => {
    setIsDrawerOpen(true);
    setIndexMachinery(undefined);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUserIndex(null);
  };

  const open = Boolean(anchorEl);

  const handleMenuClick = (event, machinery, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedUserIndex(machinery);
    setDataView(machinery);
  };

  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const handleView = () => {
    handleMenuClose();
    setViewMachinery(true);
  };

  // console.log("machine1", machinery);

  const handleEdit = () => {
    setIndexMachinery(dataView);
    setAnchorEl(null);
    setSelectedUserIndex(null);
    setIsDrawerOpen(true);
    setViewMachinery(false);
    //  setIsDrawerOpenEdit(false)
    // openDrawerEdit();
  };

  const handleDelete = () => {
    // setindexUserView(index)
    setDeleteIndex(dataView._id);
    setDeleteDialog(true);
    setAnchorEl(null);
    setSelectedUserIndex(null);

    setDeleteDialog(true);
    setAnchorEl(null);
    setSelectedUserIndex(null);
  };

  const handleDeleteAggree = async () => {
    await put(`/master/deleteMachinery?id=${DeleteIndex}`, { active: false })
      .then((res) => {
        console.log(res, "errt1");
        setDeleteDialog(false);
        setsnackOpen({
          open: true,
          message: "Machinery deleted successfully",
          severity: "success",
        });
        setAnchorEl(null);
        setSelectedUserIndex(null);

        // Remove the deleted machinery from the current list
        const deletedId = res.data.data._id; // Ensure this matches the response structure
        setMachinery((prevMachinery) =>
          prevMachinery.filter((item) => item._id !== deletedId)
        );

        // Optionally, update filteredMachinery if you're using it to render the displayed list
        setFilteredMachinery((prevFiltered) =>
          prevFiltered.filter((item) => item._id !== deletedId)
        );

        // Fetch the next page's machinery data if necessary
        if (machinery.length === 1 && page > 1) {
          setPage(page - 1); // Move to the previous page if the current page is empty after deletion
        } else {
          fetchMachinery(); // Re-fetch machinery to reflect the deletion and fill the page
        }
      })
      .catch((err) => {
        setsnackOpen({
          open: true,
          message: err?.response?.data?.message || "Error deleting machinery",
          severity: "error",
        });
      });
  };

  const handleFilterChange = (selectedCategories) => {
    setCategoryFilter(selectedCategories);
  };

  const handleNameFilterChange = (selectedMachineryNames) => {
    setMachineryNames(selectedMachineryNames);
  };

  const handleFuelFilterChange = (selectedFuelTypes) => {
    setFuelTypes(selectedFuelTypes);
  };

  const handleTypeFilterChange = (selectedTypes) => {
    setMachineTypes(selectedTypes);
  };

  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    console.log("Applying filters...");

    // Reset to first page when applying filters
    setPage(1);

    fetchMachinery();
    setSelectedCategories(tempFilter?.selectedCategories);
    setSelectedTypes(tempFilter?.selectedTypes);
    setSelectedMachineryNames(tempFilter?.selectedMachineryNames);
    setSelectedFuelTypes(tempFilter?.selectedFuelTypes);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);

    setDrawerFilterOpen(false);
    handleAppliedFilters();
  };

  const filtersToApply = {
    filterMachineCategoryType: tempFilter?.selectedCategories.join(","),
    filterMachineTypeName: tempFilter?.selectedTypes.join(","),
    filterName: tempFilter?.selectedMachineryNames.join(","),
    filterFuelType: tempFilter?.selectedFuelTypes.join(","),
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
  };

  //  Applying reset filters
  const handleResetFilters = () => {
    setTempFilter({
      selectedCategories: [],
      selectedTypes: [],
      selectedMachineryNames: [],
      selectedFuelTypes: [],
      startDate: null,
      endDate: null,
    });
    setStartDate(null);
    setEndDate(null);
    setSelectedCategories([]);
    setSelectedTypes([]);
    setSelectedMachineryNames([]);
    setSelectedFuelTypes([]);
    setIsFiltersApplied(false);
    fetchMachinery({});
    setErrors({});
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied =
      tempFilter?.startDate || tempFilter?.endDate ? true : false;
    const isCategroryApplied = tempFilter?.selectedCategories.length > 0;
    const isMachineryNameApplied =
      tempFilter?.selectedMachineryNames.length > 0;
    const isMachineTypeApplied = tempFilter?.selectedTypes.length > 0;
    // const isFunctionalityOfRoleApplied = functionalityOfRoleFilter.length > 0;
    const isFuelTypeApplied = tempFilter?.selectedFuelTypes.length > 0;

    setIsFiltersApplied(
      isDateApplied ||
        isCategroryApplied ||
        isMachineryNameApplied ||
        isMachineTypeApplied ||
        // isFunctionalityOfRoleApplied ||
        isFuelTypeApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Category: isCategroryApplied,
      MachineType: isMachineTypeApplied,
      MachineryName: isMachineryNameApplied,
      FuelType: isMachineryNameApplied,

      // FunctionalityOfRole: isFunctionalityOfRoleApplied,
    }));
    // setIsFiltersApplied(true);
  };

  const validateFilters = () => {
    let isValid = true;
    const newErrors = { Date: "", Role: "" };
    if (selectedFilter === "Date") {
      if (startDate > endDate) {
        console.log(startDate, endDate, Date.now());
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateFilter
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            errors={errors.Date}
          />
        );

      case "Machinery Category":
        return (
          <CategoryFilter
            url={`/master/getAllMachinery`}
            onFilterChange={handleFilterChange}
            selectedCategories={tempFilter?.selectedCategories}
            setSelectedCategories={(countries) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedCategories: countries,
              }))
            }
          />
        );

      case "Machinery Type":
        return (
          <MachineTypeFilter
            url={`/master/getAllMachinery`}
            onFilterChange={handleTypeFilterChange}
            selectedTypes={tempFilter?.selectedTypes}
            setSelectedTypes={(countries) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedTypes: countries,
              }))
            }
          />
        );

      case "MachineryName":
        return (
          <MachineryNameFilter
            url={`/master/getAllMachinery`}
            onFilterChange={handleNameFilterChange}
            selectedMachineryNames={tempFilter?.selectedMachineryNames}
            setSelectedMachineryNames={(countries) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedMachineryNames: countries,
              }))
            }
          />
        );

      case "Fuel Type":
        return (
          <FuelTypeFilter
            url={`/master/getAllMachinery`}
            onFilterChange={handleFuelFilterChange}
            selectedFuelTypes={tempFilter?.selectedFuelTypes}
            setSelectedFuelTypes={(countries) =>
              setTempFilter((prev) => ({
                ...prev,
                selectedFuelTypes: countries,
              }))
            }
          />
        );

      default:
        return null;
    }
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      selectedCategories: selectedCategories,
      selectedTypes: selectedTypes,
      selectedMachineryNames: selectedMachineryNames,
      selectedFuelTypes: selectedFuelTypes,
    });
    setDrawerFilterOpen(false);
    setErrors({ Date: false, Role: false });
  };

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ width: 600 }}>
            <Snackbar
              open={snackOpen.open}
              autoHideDuration={3000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={() => setsnackOpen({ ...snackOpen, open: false })}
            >
              <Alert
                // onClose={handleClose}
                severity={snackOpen.severity}
                variant="filled"
                sx={{ width: "100%" }}
              >
                {snackOpen.message}
                {/* Add user Successfully */}
              </Alert>
            </Snackbar>
            <AddMachinery
              value={isDrawerOpen}
              setValue={setIsDrawerOpen}
              index={index}
              fetchMachinery={fetchMachinery}
              setsnackOpen={setsnackOpen}
              machinery={selectedMachinery}
              indexMachinery={indexMachinery}
            />
            <View
              viewFacility={viewMachinery}
              setViewFacility={setViewMachinery}
              selectedFacility={dataView}
              setsnackOpen={setsnackOpen}
              fetchFacilities={fetchMachinery}
              handleEdit={handleEdit}
            />
          </Box>
          {drawerFilterOpen && (
            <Drawer
              anchor="right"
              open={drawerFilterOpen}
              onClose={() => handleFilterDrawer()}
              // onClose={() => setDrawerFilterOpen(false)}
              sx={{
                backgroundColor: "transparent",
                "& .MuiDrawer-paper": {
                  // This targets the paper component within the Drawer
                  backgroundColor: "transparent", // Make paper transparent
                  boxShadow: "none", // Optional: Remove any shadow
                  width: "50%",
                },
              }}
            >
              <Box
                display="flex"
                gap={3}
                sx={{
                  width: "100%",
                  display: "flex",
                  overflowX: "hidden",
                  maxWidth: "100%",
                  justifyContent: "space-btween",
                  height: "100%",
                  backgroundColor: "transparent",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#f5f5f5",
                    height: "3%",
                    padding: "13px",
                    margin: "30px 0 0 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "80%",
                    width: "4%",
                  }}
                >
                  <IconButton
                    // onClick={() => setDrawerFilterOpen(false)}
                    onClick={() => handleFilterDrawer()}
                    sx={{ color: "black" }}
                  >
                    <CloseIcon sx={{ fontSize: "1.2rem" }} />
                  </IconButton>
                </Box>
                <Box sx={{ display: "flex", width: "100%", height: "100vh" }}>
                  {/* Sidebar for selecting the filter */}
                  <FilterSidebar
                    {...{
                      setSelectedFilter,
                      selectedFilter,
                      filters,
                      appliedFilters,
                    }}
                  />

                  {/* Filter content area */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      backgroundColor: "#F9F9F9",
                      padding: "20px",
                    }}
                  >
                    {renderSelectedFilter()}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        gap: "3%",
                        position: "fixed",
                        bottom: "20px",
                        ml: 3,
                        mr: 3,
                      }}
                    >
                      <ApplyButton handleApply={handleApplyFilters} />
                      <ResetButton handleReset={handleResetFilters} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Drawer>
          )}{" "}
          {deleteDialog && (
            <Dialog
              open={deleteDialog}
              onClose={() => setDeleteDialog(false)}
              BackdropProps={{
                style: {
                  backgroundColor: "rgba(0, 0, 0, 0.3)", // Adjust the opacity as needed (0.3 is lighter)
                },
              }}
            >
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you really want to delete this entry?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setDeleteDialog(false)} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleDeleteAggree} color="secondary">
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          )}
          <Box
            sx={{
              pt: "2rem",
              // display: "flex",
              justifyContent: "space-between",
              width: "100%",
              // justifyContent: "flex-end",
              // ml: "20%",
            }}
          >
            <Box item xs={6} sx={{ paddingLeft: 0, display: "flex" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                  paddingLeft: "0",
                }}
              >
                {"Scope 1"}
              </Typography>
            </Box>
            <Box
              item
              xs={6}
              sx={{
                display: "flex",
                gap: "0.6rem",
                my: "1rem",
                justifyContent: "flex-end",
              }}
            >
              {" "}
              <Button
                variant="contained"
                onClick={() => setDrawerFilterOpen(true)}
                // endIcon={<FilterListIcon />}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "black",
                  "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                  "&:hover .dot-icon": {
                    color: "#FFFFFF", // Change dot color on button hover
                  },
                  // display:"flex"
                }}
              >
                Filter
                <FilterListIcon />
                {(tempFilter?.selectedCategories.length > 0 ||
                  tempFilter?.selectedTypes.length > 0 ||
                  tempFilter?.selectedMachineryNames.length > 0 ||
                  tempFilter?.selectedFuelTypes.length > 0 ||
                  tempFilter?.startDate ||
                  tempFilter?.endDate) && (
                  <FiberManualRecordIcon
                    className="dot-icon"
                    sx={{
                      fontSize: "10px",
                      color: "#488257",
                      marginLeft: "5px",
                    }}
                  />
                )}
              </Button>
              {!user?.companyAdmin && (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#1c486b",
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  endIcon={<AddIcon />}
                  onClick={handleAddRole}
                >
                  Add New
                </Button>
              )}
            </Box>
          </Box>
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ flex: 1, overflow: "hidden", mt: "0.5rem" }}
          >
            <Box>
              <Box sx={{ margin: "16px" }}>
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "left",
                    display: "flex",
                    flexDirection: "column",
                    // padding: "0px",
                  }}
                >
                  Machinery Master
                </Box>
              </Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 15% 16% 18% 15% 15% 9%",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 16px",
                    textAlign: "left",

                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Date
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("createdAt", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("createdAt", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Machinery Name
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("name", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "name" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("name", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "name" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Machinery Category
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("machineCategory", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "machineCategory" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("machineCategory", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "machineCategory" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Machinery Type
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("machineType", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "machineType" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("machineType", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "machineType" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>

                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Quantity of Machines
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("numberOfMachines", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "numberOfMachines" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("numberOfMachines", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "numberOfMachines" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Fuel Type
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("fuelType", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "fuelType" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("fuelType", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "fuelType" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px 8px 16px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Action
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  ></Box>
                </Typography>
              </Box>

              {filteredMachinery.length === 0 ? (
                <NoDataFound />
              ) : (
                filteredMachinery.map((machinery, index) => (
                  <Box
                    key={machinery._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "12% 15% 16% 18% 15% 15% 9%",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <Typography
                      sx={{
                        padding: "8px 16px",
                        textAlign: "left",
                        paddingLeft: "12px",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {/* {new Date(equipments.createdAt).toLocaleDateString()} */}
                      {formatDateMonth(machinery.createdAt)}
                    </Typography>

                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {machinery.name}
                    </Typography>

                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {machinery.machineCategory?.type || "N/A"}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {machinery.machineType?.name || "N/A"}
                    </Typography>

                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {machinery.numberOfMachines}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {machinery.fuelType}
                    </Typography>
                    <Box
                      sx={{
                        padding: "1px",
                        textAlign: "center",
                      }}
                    >
                      <IconButton
                        onClick={(event) =>
                          handleMenuClick(event, machinery, index)
                        }
                      >
                        <MoreHorizIcon
                          sx={{ fontWeight: "bold", color: "black" }}
                        />
                      </IconButton>
                    </Box>
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Action Menu */}
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            PaperProps={{
              sx: {
                width: "120px",
                border: "1px solid #ddd",
                marginLeft: "-47px",
              },
            }}
          >
            {user?.companyAdmin ? (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
              </>
            ) : (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
                <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
                  <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Edit
                </MenuItem>
                <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
                  <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Delete
                </MenuItem>
              </>
            )}
          </Menu>
          {totalPages > 1 && (
            <PaginationBox
              totalPages={totalPages}
              page={page}
              handleChangePage={handleChangePage}
              StyledPaginationItem={StyledPaginationItem}
              isShortContent={isShortContent} // Pass this state to PaginationBox
            />
          )}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Machinery;
